// src/components/WalletConnection.jsx
import React, { useEffect } from 'react';
import { 
  PhantomWalletAdapter,
  SolflareWalletAdapter,
  TorusWalletAdapter,
  LedgerWalletAdapter,
  CoinbaseWalletAdapter,
  TrustWalletAdapter,
} from '@solana/wallet-adapter-wallets';
import { 
  ConnectionProvider, 
  WalletProvider, 
  useWallet 
} from '@solana/wallet-adapter-react';
import { 
  WalletModalProvider, 
  WalletMultiButton,
  WalletDisconnectButton
} from '@solana/wallet-adapter-react-ui';
import '@solana/wallet-adapter-react-ui/styles.css';

// Component to handle wallet connection and disconnection
const WalletConnection = ({ onWalletConnected, onWalletDisconnected, connected }) => {
  const { publicKey, connected: walletConnected } = useWallet();
  
  useEffect(() => {
    if (walletConnected && publicKey) {
      // Pass the wallet address to the parent component when connected
      onWalletConnected(publicKey.toString());
    } else if (!walletConnected && connected) {
      // Notify the parent component about disconnection
      onWalletDisconnected && onWalletDisconnected();
    }
  }, [walletConnected, publicKey, onWalletConnected, onWalletDisconnected, connected]);
  
  return (
    <div className="wallet-connection">
      {!connected ? (
        <WalletMultiButton />
      ) : (
        <WalletDisconnectButton />
      )}
    </div>
  );
};

// Provider wrapper for the application
export const WalletConnectionProvider = ({ children }) => {
  // Initialize supported wallet adapters
  const wallets = [
    new PhantomWalletAdapter(),
    new SolflareWalletAdapter(),
    new TorusWalletAdapter(),
    new LedgerWalletAdapter(),
    new CoinbaseWalletAdapter(),
    new TrustWalletAdapter(),
  ];
  
  return (
    <ConnectionProvider endpoint="https://api.mainnet-beta.solana.com">
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          {children}
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
};

export { WalletMultiButton, WalletDisconnectButton };
export default WalletConnection;